import React from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import LoyaltyOutlinedIcon from "@mui/icons-material/LoyaltyOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";

import { ACTIVITY_TABS } from "../dashboardConstants";

const SECTION_ICON = {
  overview: DashboardOutlinedIcon,
  bookings: CalendarMonthOutlinedIcon,
  terms: SchoolOutlinedIcon,
  packages: LoyaltyOutlinedIcon,
  invoices: ReceiptLongOutlinedIcon,
  preferences: TuneOutlinedIcon
};

function SectionMenu({ onSelect }) {
  return (
    <List disablePadding>
      {ACTIVITY_TABS.map(({ value, label }, i) => {
        const Icon = SECTION_ICON[value];
        return (
          <ListItemButton key={value} onClick={() => onSelect(value)} sx={{ py: 1.75, borderTop: i === 0 ? 0 : 1, borderColor: "divider" }}>
            <ListItemIcon sx={{ minWidth: "2.75rem", color: "primary.main" }}>{Icon ? <Icon /> : null}</ListItemIcon>
            <ListItemText primary={label} primaryTypographyProps={{ fontWeight: 600, fontSize: "0.95rem" }} />
            <ChevronRightIcon sx={{ color: "text.secondary" }} />
          </ListItemButton>
        );
      })}
    </List>
  );
}

export default SectionMenu;
